import React, { useState, useEffect } from 'react';

import { apiGet, getAccountsApiUrl } from '../common/AppApi';
import AdminAgencies from '../program/ProgramAgencies';

export default function Agencies() {
	let [programs, setPrograms] = useState([]);
	let getPrograms = () => {
		let url = getAccountsApiUrl() + '/account/programs';
		apiGet(url).then((resp) => {
			let programs = [];
			programs.push({id:'',text:''});
			resp.forEach( (p) => {
				programs.push({id:p.programUuid, text:p.programName});
			});
			setPrograms(programs);
		}).catch( (err) => {
			console.error(err);
		});
	};

	useEffect(() => {
		getPrograms();
	}, []);


	return (
		<>
		<AdminAgencies programs={programs}/>
		</>
	)
}
